export default "__VITE_ASSET__DmDGm1GL__"